import { LayoutSize, responsiveLayoutSize } from '../utils/useLayoutSize';

const showFullPageSheet = () => responsiveLayoutSize() === LayoutSize.mobile;

export default showFullPageSheet;
